// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2rRER","clinicsSelect":"TableHeading_clinicsSelect__3hvDi"};